import { post } from "../../helpers/api";
import { showToast as toast } from "../../components/Modals/toast";
import { i18n } from "../../main"; // Adjust the import path accordingly
import { filterItemsPosList } from "../../utils/filterItemsPos";

const state = {
  items: [],
  isLoadingData: true,
  isBtnLoading: false,
  isBtnEditLoading: false,
  search: "",
  isShowResultDialog: false,
  resultMsg: "",
  isSuccess: false,
  itemsPOS: [],
  searchPos: "",
  ca_id: "",
  currentReturnPurchase: {},
};

const mutations = {
  SET_IS_BTN_LOADING(state, isBtnLoading) {
    state.isBtnLoading = isBtnLoading;
  },
  SET_IS_LOADING_DATA(state, isLoadingData) {
    state.isLoadingData = isLoadingData;
  },
  SET_edit_purchase_CLEAR(state) {
    state.items = [];
    state.isLoadingData = true;
    state.isBtnLoading = false;
    state.isBtnEditLoading = false;
    state.search = "";
    state.isShowResultDialog = false;
    state.resultMsg = "";
    state.isSuccess = false;
    state.itemsPOS = [];
    state.searchPos = "";
    state.ca_id = "";
    state.currentReturnPurchase = {};
  },

  REMOVE_ITEM(state, id) {
    state.items = state.items.filter((item) => {
      return item.i_id !== id;
    });
  },

  SET_SEARCH_POS(state, search) {
    state.searchPos = search;
  },
  SET_DELETE_SUCCESS(state, value) {
    state.isShowResultDialog = value.state;
    state.resultMsg = value.msg;
    state.isSuccess = value.isSuccess;
  },

  SET_ITEMS_POS(state, itemsPOS) {
    state.itemsPOS = itemsPOS;
  },
  SET_CURRENT_PURCHASE(state, currentReturnPurchase) {
    state.currentReturnPurchase = currentReturnPurchase;
  },
};

const actions = {
  async getItemsPOS({ commit }, payload) {
    try {
      return post("item/get-items-purchase", payload)
        .then((response) => {
          commit("SET_ITEMS_POS", response.data);
          commit("SET_IS_BTN_LOADING", false);
          commit("SET_IS_BTN_EDIT_LOADING", false);
          commit("SET_IS_LOADING_DATA", false);
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async getcurrentReturnPurchase({ commit }, payload) {
    try {
      return post(
        "returns-suplier/get-return-purchased/" + payload.rep_id,
        {},
        {
          id: 18,
          action: "detail",
        }
      )
        .then((response) => {
          commit("SET_CURRENT_PURCHASE", response.data);
          //SET_IS_LOADING_DATA
          commit("SET_IS_LOADING_DATA", false);

          return response;
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 408) {
            window.location.href = "/404";
          }
          return error;
        });
    } catch (error) {
      console.log(error);
    }
  },
  async editItem({ commit }, payload) {
    return post("returns-suplier/edit/" + payload.rep_id, payload, {
      id: 18,
      action: "edit",
    })
      .then((response) => {
        const t = i18n.global.t;
        toast("success", t("edited_successfully"));
        return response;
      })
      .catch((error) => {
        commit("SET_IS_BTN_LOADING", false);
        const t = i18n.global.t;
        if (error.response.status == 408) {
          //you don't have permission to add new item message in toast
          toast("error", t("you_dont_have_permission_to_do_this_action"));
          return error;
        }
        if (error.response.status === 505) {
          toast("error", t("you_didnt_buy_this_item_from_this_suplier_before"));
          return error;
        }
        //Item quantity in storage is less than returned item to suplier

        if (
          error.response.data.message.includes(
            "Item quantity in storage is less than returned item to suplier"
          )
        ) {
          toast("error", t("item_quantity_less_than_returned_item_to_suplier"));
        } else {
          toast("error", t("something_wrong"));
        }
        console.log(error);
        return error;
      });
  },
  async deleteItem({ commit }, id) {
    return post(
      "returns-suplier/delete/" + id,
      {},
      {
        id: 18,
        action: "delete",
      }
    )
      .then((response) => {
        const t = i18n.global.t;
        toast("success", t("deleted_successfully"));
        //route window
        return response;
      })
      .catch((error) => {
        const t = i18n.global.t;

        commit("SET_IS_BTN_LOADING", false);
        console.log(error);
        if (error.response.status == 408) {
          //you don't have permission to add new item message in toast
          toast("error", t("you_dont_have_permission_to_do_this_action"));
          return error;
        }
        if (
          error.response.data.message.includes(
            "Cannot delete or update a parent row"
          )
        ) {
          commit("SET_DELETE_SUCCESS", {
            state: true,
            msg: t(
              "you_can_not_delete_this_item_because_there_are_related_items"
            ),
            isSuccess: false,
          });
        } else {
          commit("SET_DELETE_SUCCESS", {
            state: true,
            msg: t("something_wrong"),
            isSuccess: false,
          });
        }
        return error;
      });
  },
};

const getters = {
  filterItemsPOS(state) {
    return filterItemsPosList(state.itemsPOS, {
      ca_id: state.ca_id,
      searchPos: state.searchPos,
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
